import React from 'react';
import {
  ChakraProvider,
  Stack,
  extendTheme
} from '@chakra-ui/react';
import SimpleSidebar from './SimpleSidebar';
import Hero from './Hero';
import Features from './Features';
import Footer from './Footer';
import ContactForm from './ContactForm';
import Websites from './Websites';
import Apps from './Apps';

const theme = extendTheme({
	colors: {
		pink: {
			600: "#B83280",
		},
	},
})

function App() {
	return (
		<ChakraProvider theme={theme}>
			<SimpleSidebar>
				<Hero />
				<Features />
				<Websites />
				<Apps />
				<ContactForm />
				<Footer />
			</SimpleSidebar>
		</ChakraProvider>
	);
}

export default App;
